
import { PiShieldWarningDuotone } from "react-icons/pi";
import { FiEye, FiEyeOff } from "react-icons/fi";
import CancelButton from "../../../Components/CommonComponent/Button/CancelButton";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export default function DeleteDataModal({
  selectedLedger,
  handleDeleteModalClose,
  handleDeleteLedgerApi,
  showinputFields = false,
}) {
  const { t } = useTranslation();

  const [reason, setReason] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = () => {
    if (showinputFields) {
      const newErrors = {};
      if (!reason.trim()) newErrors.reason = t("Reason is required");
      if (!password.trim()) newErrors.password = t("Password is required");

      if (Object.keys(newErrors).length) {
        setErrors(newErrors);
        return;
      }
    }

    handleDeleteLedgerApi({
      ...selectedLedger,
      deleteReason: reason,
      deletePassword: password,
    });
  };

  return (
    <div
      className="fixed inset-0 bg-black/20 bg-opacity-40 flex justify-center items-center z-[1000]"
      onClick={handleDeleteModalClose}
    >
      <div
        className={`rounded ${showinputFields ? "max-w-lg" : "max-w-sm"}  text-start w-full shadow-lg overflow-hidden bg-white p-2`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ===== Icon ===== */}
         {!showinputFields &&  <div className="bg-theme-bg text-center rounded mb-2">
          <div className="font-semibold bg-theme-headerBg rounded-1 text-theme-color py-[4px]">
           {t("deleteLedger")}
           </div>
        </div>}

        <div className="flex justify-center mb-1">
          <div className="text-[60px] text-theme-createLedgerColor">
            <PiShieldWarningDuotone />
          </div>
        </div>

        {/* ===== Heading ===== */}
        <div className="text-red-500 px-2 text-center font-medium">
          {t("confirmDelete")}{" "}
          <strong className="text-theme-tabHoverColor">
            {selectedLedger?.name ||
              selectedLedger?.groupName ||
              (selectedLedger?.first_name && selectedLedger?.last_name
                ? `${selectedLedger.first_name} ${selectedLedger.last_name}`
                : selectedLedger?.first_name || selectedLedger?.last_name)}
          </strong>
          ?
        </div>

        {/* ===== Sub Heading ===== */}
       {showinputFields && <div className="px-2 mb-2 text-xs text-gray-500 text-center">
          {t("confirmDeleteSubHeading")}
        </div>} 

        {/* ===== Show inputs only when true ===== */}
        {showinputFields && (
          <>
            {/* Reason */}
            <label
              htmlFor="deleteReason"
              className="px-2 block mb-1 text-sm font-medium text-gray-700"
            >
              {t("removeReason")}
            </label>
            <div className="mb-2 px-2">
              <textarea
                id="deleteReason"
                placeholder={t("Enter delete reason")}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className={`w-full border rounded-1 px-2 py-1 text-sm outline-none resize-none ${
                  errors.reason ? "border-red-500" : "border-gray-300"
                }`}
                rows={3}
              />
              {errors.reason && (
                <p className="text-red-500 text-xs mt-1">{errors.reason}</p>
              )}
            </div>

            {/* Password */}
            <div className="mb-4 px-2 relative">
              <label
                htmlFor="deletePassword"
                className="block mb-1 text-sm font-medium text-gray-700"
              >
                {t("password")}
              </label>
              <input
                id="deletePassword"
                type={showPassword ? "text" : "password"}
                placeholder={t("Enter password")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`w-full border rounded px-2 py-1 pr-9 text-sm outline-none ${
                  errors.password ? "border-red-500" : "border-gray-300"
                }`}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-10 -translate-y-1/2 cursor-pointer text-gray-500"
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </span>

              {errors.password && (
                <p className="text-red-500 text-xs mt-1">{errors.password}</p>
              )}
            </div>
          </>
        )}

        {/* ===== Buttons ===== */}
        <div className={`flex justify-end gap-2 px-2 pb-1 ${showinputFields ? "" : "mt-4"}`}>
          <CancelButton onClick={handleDeleteModalClose} text={t("cancel")} />
          <button
            onClick={handleSubmit}
            className={`px-3 py-[2px] text-theme-headerBg border-1 border-theme-headerBg hover:bg-theme-headerBg hover:text-theme-color rounded-1 transition-colors `}
          >
            {t("delete")}
          </button>
        </div>
      </div>
    </div>
  );
}
